import { RecordSource, Store } from 'relay-runtime';

function createStore() {
  const source = new RecordSource();
  const store = new Store(source);
  return store;
}

export { createStore };
